import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {BaseUrlConstantsService} from './services/base-url-constants.service';
@Injectable({
  providedIn: 'root'
})
export class ClientSubscriptionService {
  public middlewareBaseUrl= BaseUrlConstantsService.BASE_MIDDLEWARE_URL
  constructor(private http: HttpClient) { }
  getSubscriptionService(clientId: any) {
    const apiUrl = this.middlewareBaseUrl+`get-tabStatus/${clientId}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': token
    });

    return this.http.get(apiUrl, { headers });
  }
}
